import { call, put, select, takeLatest } from 'redux-saga/effects';

import { addCustomGTMEvent } from '../../../events/googleTagManager';
import { formatError } from '../../../libs';
import customerAPI from '../../api/customer';
import { Creators, Types } from '../../reducers/customer';
import { getCartId, getLeadCookie } from '../../utils/cookies';
import { signInUser } from '../../utils/cookiesUser';
import getState from '../../utils/getState';

function* loginRequest({ user: { login, password } }) {
  try {
    const { cart, app } = yield select(getState);

    const domain = app.getIn(['config', 'domain']);
    const siteId = app.getIn(['config', 'siteId']);

    const cartId = cart.id || getCartId();
    const leadPhone = getLeadCookie(domain);

    const body = {
      password,
      origin: 'INTERNET',
    };

    if (cartId) body.cartId = cartId;

    const data = yield call(customerAPI.login, login, body, siteId);

    if (data.id) signInUser({ ...data, domain });

    if (!data.id) throw new Error(data.message);

    try {
      yield call(customerAPI.deleteLeadByCartId, siteId, cartId);
    } catch (e) {
      console.log(e);
    }

    addCustomGTMEvent({
      event: 'sucess_login',
      data: {
        customer_name: data.name,
      },
    });
    if (leadPhone) {
      addCustomGTMEvent({
        event: 'success_client_login',
        data: { action: 'success_client_login' },
      });
    }

    yield put(Creators.loginSuccess(data));
  } catch (error) {
    addCustomGTMEvent({
      event: 'fail_login',
      data: {
        error: error?.message || '',
      },
    });
    yield put(Creators.loginFailed(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.LOGIN_REQUEST, loginRequest);
}
